import "reflect-metadata";
import { lazy } from "react";
import { injectable, registry } from "tsyringe";
import { FeatureSetupDef, FeatureRootRoute, FeatureSetup } from "../../src/types/feature.types";
import { featurePaths } from "@feature/constants/paths.constant";
import { version, name } from "@feature/package.json";
import { FeatureToken } from "../../src/constants/di";

const JobServiceListPage = lazy(() => import("@feature/pages/jobservice/JobServiceList"));
const ServiceDetailPage = lazy(() => import("@feature/pages/jobservice/ServiceDetail"));
const PrintLabelsPage = lazy(() => import("@feature/components/PrintLabelsPage"));
const SustainabilityReportPage = lazy(() => import("@feature/pages/jobservice/SustainabilityReport"));
const PrintNonPrintedLabelsPage = lazy(() => import("@feature/components/PrintNonPrintedLabelsPage"));

const PrintShippingDetails = lazy(() => import("@feature/components/PrintShippingDetails"));
const PrintLabelsShippinglabels = lazy(() => import("@feature/components/PrintLabelsShippinglabels"));

@injectable()
@registry([{ token: FeatureToken, useClass: ServiceManagement }])
class ServiceManagement implements FeatureSetupDef {
    GetFeatureSetup(): FeatureSetup {
        return {
            version,
            namespace: name,
            featuresRoot: this.features,
            permissions: [],
            index: true
        };
    }
    
    private readonly features: FeatureRootRoute = {
        requiredPermissions: [],
        children: [
            {
                title: "Job Service",
                path: featurePaths.jobServiceList,
                page: JobServiceListPage
            },
            {
                title: "Edit Service",
                path: "/jobservice/editservice",
                page: ServiceDetailPage
            },
            {
                title: "PrintLabelsPage",
                path: "/AddLabels/PrintLabelsPage",
                page: PrintLabelsPage
            },
            {
                title: "SustainabilityReportPage",
                path: featurePaths.sustainabilityReport,
                page: SustainabilityReportPage
            },
            {
                title: "PrintNonPrintedLabelsPage",
                path: "/AddLabels/PrintNonPrintedLabelsPage",
                page: PrintNonPrintedLabelsPage
            },
            {
                title: "PrintLabelsShippinglabels",
                path: "/addLabels/PrintLabelsShippinglabels",
                page: PrintLabelsShippinglabels
            },
            {
                title: "PrintShippingDetails",
                path: "/addLabels/PrintShippingDetails",
                page: PrintShippingDetails
            }
        ]
    };
}